export default __webpack_public_path__ + "9efd675ca8a80e20c4719b1f434c5ff5.png";